import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { AuthService, Tab, UserRole } from "src/app/core";

export const reportResolver: ResolveFn<Tab[]> = (route, state) => {
  const userRole = inject(AuthService).userRole();
  const statisticalReport = {
    key: "STATISTICALREPORT",
    title: "REPORTS.STATISTICAL_REPORT",
    routerLink: "statistical",
  };

  const financialReport = {
    key: "FINANCIALREPORT",
    title: "REPORTS.FINANCIAL_REPORT",
    routerLink: "financial",
  };

  const evaluationForm = {
    key: "EVALUATIONFORM",
    title: "FRIENDS_OF_OMAN_MUSEUM.EVALUATION_FORM",
    routerLink: "evaluation-form",
  };

  const standardFinancialReport = {
    key: "STANDARDFINANCIALREPORT",
    title: "REPORTS.STANDARD_FINANCIAL_REPORT",
    routerLink: "standard",
  };

  const intrestsCardsReport = {
    key: "INTRESTSCARDSREPORT",
    title: "MY_PROFILE.INTERESTS_CARD",
    routerLink: "intrests-cards",
  };

  const statisticsVisitorReport = {
    key: "STATISTICSVISITORREPORT",
    title: "REPORTS.STATISTICS_VISITOR_REPORT",
    routerLink: "statistics-visitor",
  };

  const productsReport = {
    key: "PRODUCTSREPORT",
    title: "REPORTS.PRODUCTS_REPORT",
    routerLink: "products",
  };

  const peakHoursReport = {
    key: "PEAKHOURSREPORT",
    title: "REPORTS.PEAK_HOURS_REPORT",
    routerLink: "peak-hours",
  };

  const reportsPerRole = {
    [UserRole.STATISTICSDEPARTMENT]: [statisticalReport, peakHoursReport],
    [UserRole.FINANCEDEPARTMENT]: [financialReport],
    [UserRole.LEARNINGCENTER]: [statisticalReport],
    [UserRole.MUSEUMFRIENDSDEPARTMENT]: [statisticalReport, intrestsCardsReport, evaluationForm],
  };

  if (userRole && userRole in reportsPerRole) {
    return reportsPerRole[userRole as keyof typeof reportsPerRole];
  }

  return [
    statisticalReport,
    financialReport,
    evaluationForm,
    intrestsCardsReport,
    standardFinancialReport,
    statisticsVisitorReport,
    productsReport,
    peakHoursReport,
  ];
};
